jQuery(document).ready(function($) {
    // No-Module Component Loader
    const componentLoader = {
        // Define your components here - simplified with just name and selector
        components: [
            {
                name: 'smooth_scroll',
                selector: 'body' // Always load on every page
            },
            
            // Accordion Components
            {
                name: 'simple_accordion',
                selector: '.component__simple_accordion'
            },
            {
                name: 'image_accordion',
                selector: '.component__image-accordion'
            },
            
            // Counter Components
            {
                name: 'counter',
                selector: '[data-count]'
            },

            // GSAP Animation Components
            {
                name: 'animations',
                selector: '[data-swipe]'
            },
            {
                name: 'list_animations',
                selector: '[data-animate-list]'
            },
            // Google Maps Component
            {
                name: 'google_map',
                selector: '.acf-map'
            },
    
            
            // Image Components
            {
                name: 'image_with_icons',
                selector: '.component__image_with_icons'
            },

             // Image Components
            {
                name: 'video',
                selector: '.component__video'
            },
            
            // Slider Components
            {
                name: 'content_slider',
                selector: '.component__content_slider'
            },
            {
                name: 'simple_testimonial',
                selector: '.component__simple_testimonial'
            },
            {
                name: 'dynamic_content_slider',
                selector: '.component__dynamic_content_slider'
            },
            {
                name: 'featured_developments',
                selector: '.component__featured_developments'
            },
            {
                name: 'feature_slider',
                selector: '.component__feature_slider'
            },
            {
                name: 'image_slider',
                selector: '.component__image_slider'
            },
            {
                name: 'development_slider',
                selector: '.component__development_slider'
            },
            {
                name: 'property_slider',
                selector: '.component__property_slider'
            },
            
            // Tab Components
            {
                name: 'fullwidth_tabs',
                selector: '.component__fullwidth_tabs'
            },
            
            // Fancybox Component - Enhanced with video URL detection
            {
                name: 'fancybox',
                selector: 'a[href*="youtube.com"], a[href*="youtu.be"], a[href*="vimeo.com"], a[href*="wistia.com"], a[href*="wi.st"], a[href*="dailymotion.com"], a[href*=".mp4"], a[href*=".webm"], a[href*=".ogg"], a[href*=".mov"], a[href*=".avi"], a[href*=".wmv"], a[href*=".flv"], a[href*=".m4v"], [data-fancybox], .fancybox, .popup-trigger'
            }
        ],
        
        // Get the path based on component name
        getComponentPath: function(componentName) {
            return `/wp-content/themes/exitedfounders/dist/js/components/${componentName}.js`;
        },

        // Get CSS path for components that need it
        getComponentCSSPath: function(componentName) {
            // Map component names to their CSS files
            const cssMap = {
                'fancybox': '/wp-content/themes/exitedfounders/node_modules/@fancyapps/ui/dist/fancybox/fancybox.css'
            };
            return cssMap[componentName] || null;
        },
        
        // Load CSS file
        loadCSS: function(componentName) {
            const cssPath = this.getComponentCSSPath(componentName);
            if (!cssPath) return Promise.resolve();
            
            return new Promise((resolve, reject) => {
                // Check if CSS is already loaded
                if (document.querySelector(`link[href="${cssPath}"]`)) {
                    return resolve();
                }
                
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = cssPath;
                
                link.onload = () => resolve();
                link.onerror = (e) => {
                    console.error(`Failed to load CSS: ${cssPath}`, e);
                    reject(new Error(`Failed to load CSS: ${cssPath}`));
                };
                
                document.head.appendChild(link);
            });
        },
        
        // Load a script by creating a script tag
        loadScript: function(componentName) {
            const url = this.getComponentPath(componentName);
            
            return new Promise((resolve, reject) => {
                // Check if script is already loaded
                if (document.querySelector(`script[src="${url}"]`)) {
                    return resolve();
                }
                
                // Create the script element
                const script = document.createElement('script');
                script.src = url;
                
                // Set to false for HTTP/2 optimization - allows browser to better prioritize
                script.async = false;
                
                script.onload = () => {
                    resolve();
                };
                
                script.onerror = (e) => {
                    console.error(`Failed to load script: ${url}`, e);
                    reject(new Error(`Failed to load: ${url}`));
                };
                
                document.head.appendChild(script);
            });
        },
        
        // Debug helper to show what video links were found
        debugVideoLinks: function() {
            const videoSelectors = [
                'a[href*="youtube.com"]',
                'a[href*="youtu.be"]', 
                'a[href*="vimeo.com"]',
                'a[href*="wistia.com"]',
                'a[href*="dailymotion.com"]',
                'a[href*=".mp4"]',
                'a[href*=".webm"]',
                'a[href*=".ogg"]'
            ];
            
            // console.group('Video Links Found:');
            videoSelectors.forEach(selector => {
                const found = document.querySelectorAll(selector);
                // if (found.length > 0) {
                //     // console.log(`${selector}:`, found.length, 'links');
                //     found.forEach(link => console.log('  -', link.href, link));
                // }
            });
            console.groupEnd();
        },
        
        // Initialize all components
        init: function() {
            // Track loaded components to prevent duplicate loading
            if (!this.loadedComponents) {
                this.loadedComponents = new Set();
            }
            
            // First identify all needed components
            const componentsToLoad = this.components.filter(component => {
                const hasElements = $(component.selector).length > 0;
                const notLoaded = !this.loadedComponents.has(component.name);
                
                // Special debug logging for fancybox
                if (component.name === 'fancybox' && hasElements) {
                    this.debugVideoLinks();
                }
                
                return hasElements && notLoaded;
            });
            
            console.log('Components to load:', componentsToLoad.map(c => c.name));
            
            // If using HTTP/2, we can load scripts in parallel more efficiently
            const loadPromises = componentsToLoad.map(component => {
                const elements = $(component.selector);
                
                // console.log(`Found ${elements.length} elements for ${component.name}:`, elements.toArray());
                
                // Mark as loading to prevent duplicate attempts
                this.loadedComponents.add(component.name);
                
                // Before loading the component, set up a global function that the component will call
                window[`init_${component.name}`] = function(componentModule) {
                    try {
                        // Convert jQuery collection to array if needed
                        const elementsArray = elements.toArray();
                        // console.log(`Initializing ${component.name} with elements:`, elementsArray);
                        componentModule.init(elementsArray);
                    } catch (err) {
                        console.error(`Error initializing ${component.name}:`, err);
                    }
                };
                
                // Load CSS first (if needed), then JS
                return this.loadCSS(component.name)
                    .then(() => this.loadScript(component.name))
                    .catch(err => {
                        console.error(`Error loading ${component.name}:`, err);
                        // Remove from loaded set if it failed to load
                        this.loadedComponents.delete(component.name);
                    });
            });
            
            // Optional: If you want to track when all components are loaded
            Promise.all(loadPromises).then(() => {
                console.debug('All components loaded successfully');
            });
        },
        
        // Method to re-scan for new components (useful for AJAX content)
        refresh: function() {
            // console.log('Refreshing component loader...');
            this.init();
        }
    };
    
    // Initialize the component loader
    componentLoader.init();
    
    // Make loader available globally for manual refresh
    window.componentLoader = componentLoader;
    
    // Optional: Auto-refresh on AJAX complete (if you use AJAX content loading)
    $(document).ajaxComplete(function() {
        setTimeout(() => {
            componentLoader.refresh();
        }, 100);
    });
});